export default {
    HEADER: 'Nested product',
    PLACEHOLDER_NAME: 'Enter nested product name',
    LABEL_NAME: 'Nested product name',
    LABEL_PRICE: 'Price',
    PLACEHOLDER_PRICE: 'Enter price',
    PLACEHOLDER_DISCOUNTED_PRICE: 'Enter discounted price',
    LABEL_DISCOUNTED_PRICE: 'Discounted price',
    LABEL_PLACE: 'Place',
    LABEL_PRODUCT_CATECORY: 'Category',
    LABEL_STATUS: 'Status',
    PLACEHOLDER_DESCRIPTION: 'Enter description',
    LABEL_DESCRIPTION: 'Description',
    LABEL_COMPANY: 'Company',
    SAVE_BUTTON: 'Save',
    CANCEL_BUTTON: 'Cancel',
    DISCOUNTED_PRICE_INFO:
        'The discounted price field is disabled until you enter a price. Please leave the field empty if there is no discount. For the discounted price amount, enter a value greater than 0 and less than the price value!',
    INDIVIDUAL_PRICES: 'Individual prices',
    UPDATE_ALL_CONFIGS: 'Update product in every place',
};

export const PRODUCT_FORM_VALIDATIONS = {
    PRICE_REQUIRED: 'Field is required',
    PRICE_POSITIVE: 'Must be positive',
    PRICE_NUMBER: 'Must be a number',
    DISCOUNTED_PRICE_LOWER_THAN_PRICE: 'Discounted price must be lower than price',
    DISCOUNTED_PRICE_POSITIVE: 'Must be positive',
    DISCOUNTED_PRICE_NUMBER: 'Must be a number',
};
